import styled, { css } from 'styled-components';

import { ReactComponent as TrashIconBase } from 'assets/icons/primary-trash.svg';

export type TrashIconStylesProps = {
  disabled?: boolean;
};

export const TrashIcon = styled(TrashIconBase)<TrashIconStylesProps>(
  ({ disabled, theme }) => css`
    cursor: pointer;
    opacity: ${disabled ? 0.5 : 1};
    width: 24px;
    height: 24px;
    vertical-align: middle;
    margin-top: 2px;

    path {
      fill: ${disabled ? theme?.palette?.grey?.[600] || '#BDBDBD' : '#2D6CE6'};
    }
  `,
);
